module.exports = __webpack_public_path__ + "static/manage-e1f8fa49c15531624a5e6835fe0ad68a.gif";